import * as coach from './coach'
import * as dashboard from './dashboard'
import * as activity from './activity'
import * as course from './course'
import * as member from './member'
import * as program from './program'
import * as whiteList from './whiteList'
import * as manufacturer from './manufacturer'
import admin from './admin'
import dealer from './dealer'
import shop from './shop'
import * as staff from './staff'
import * as client from './client'

export default {
  coach, dashboard, activity, course, member, program, whiteList, manufacturer, admin, dealer, shop, staff, client
}



// WEBPACK FOOTER //
// ./src/services/api/index.js